import { ReactNode } from "react";

type Props = { title?: string; children: ReactNode; className?: string; eyebrow?: string };

export default function Card({ title, children, className = "", eyebrow }: Props) {
  return (
    <div className={`rounded-2xl bg-white/90 shadow-[0_24px_60px_-45px_rgba(16,24,40,0.7)] ring-1 ring-black/5 backdrop-blur ${className}`}>
      {(title || eyebrow) && (
        <div className="border-b border-black/5 px-6 py-4">
          {eyebrow && <p className="text-xs font-semibold uppercase tracking-[0.2em] text-emerald-700">{eyebrow}</p>}
          {title && <h2 className="mt-1 text-lg font-semibold text-[#1a1c18]">{title}</h2>}
        </div>
      )}
      <div className="px-6 py-6">{children}</div>
    </div>
  );
}
